import { gsap } from '../lib/gsap';
import { prefersReducedMotion } from '../lib/lenis';

// Light scroll parallax: the hero app frame drifts up as it scrolls into
// view; any [data-parallax] element gets a subtle -8% drift.
export function initParallax(): void {
  if (prefersReducedMotion()) return;

  const frame = document.querySelector<HTMLElement>('[data-hero-frame]');
  if (frame) {
    gsap.to(frame, {
      yPercent: -5,
      ease: 'none',
      scrollTrigger: { trigger: frame, start: 'top 68%', end: 'bottom top', scrub: 0.6 },
    });
  }

  gsap.utils.toArray<HTMLElement>('[data-parallax]').forEach((el) => {
    gsap.to(el, {
      yPercent: -8,
      ease: 'none',
      scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: 0.8 },
    });
  });
}
